<!--  -->
<template>
<div style="overflow: hidden;" class=''>
  <Nav :navList="navList"></Nav>
  <transition name="el-zoom-in-center">
  <div id="show" v-show="show">
    <div v-show="sortData==undefined||sortData.length==0">
      <el-image style=" border-radius: 10px;border:1px solid gray;display: flex;align-items: center;justify-content: center;" :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'">
        <div slot="error" style="font-size:25px;color:gray">
          {{message}}
        </div>
      </el-image>
    </div>
    <div v-show="sortData.length>0" v-for="(item,index) in sortData" :key="item.id" @click="toTheList(item.id)">
      <div @mouseleave="showIndex=0" v-show="showIndex==index+1"></div>
      <el-image @mouseover="showIndex=index+1" :src="item.backImg"></el-image>
      <h1>{{item.name}}</h1>
    </div>
  </div>
  </transition>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from "@/components/Nav";
import {querySort,addNum} from '@/api/web/corporateImage'
import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {Nav},
data() {
//这里存放数据
return {
  navList:["形象大片"],
  showIndex:0,
  show:false,
  sortData:[],
  message:"请稍等,正在加载中......"
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
 toTheList(id){
   addNum({id:id})
   this.$router.push({name:'corporateImageShow',params:{id:id}})
 }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.show=true
  var _this = this
  setTimeout(()=>{
    if(_this.sortData.length==0||_this.sortData==undefined||_this.sortData==null){
      _this.message="很抱歉!分类信息加载失败,请重新加载页面"
    }
  },loadingTime)
  querySort().then(({data})=>{
    _this.sortData=data
  },()=>{
    _this.message="很抱歉!分类信息加载失败,请重新加载页面"
  })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.el-image{
  width:380px;
  height:660px;
  
  ::v-deep .el-image__inner {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 280px;
    height: 480px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 560px;
    object-fit: cover;
  }
}
#show{
  width:1700px;
  height:660px;
  display:flex;
  justify-content:space-between;
  margin-top:200px;
  margin-left:120px;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 90%;
    margin-left: 5%;
    margin-top: 150px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-left: 0;
    margin-top: 70px;
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 0 15px 30px 15px;
    box-sizing: border-box;
  }
}
#show div{
  width:380px;
  height:660px;
  position: relative;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 280px;
    height: 480px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 560px;
    margin-bottom: 50px;
    position: relative;
  }
}
#show div div{
  width:380px;
  height:660px;
  position:absolute;
  z-index:100;
  cursor:pointer ; 
  animation-name: show;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 280px;
    height: 480px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 560px;
  }
}
#show div .el-image{
  cursor:pointer;
  position:absolute;
  z-index:50;
  
  ::v-deep .el-image__inner {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 560px;
    max-width: 100%;
  }
}
#show div h1{
  position:absolute;
  z-index:150;
  letter-spacing: 2px;
  color:white;
  text-align: center;
  bottom: 20px;
  left: 0;
  right: 0;
  font-size:40px;
  text-shadow:0px 0px 2px rgb(255, 255, 255);
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    font-size: 32px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 18px;
    letter-spacing: 1px;
  }
}
@keyframes show {
  to{
   background:rgba(0,0,0,0.1)
  }
}

</style>